import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import swal from 'sweetalert2';
import { Flex, Button, Select, Checkbox, Icon, TooltipMenu } from '@haldor/ui';
import GenerateBaseGroupsRandomly from './GenerateBaseGroupsRandomly';
import './BaseGroupForm.scss';

var BaseGroupForm = /*#__PURE__*/function (_Component) {
  _inherits(BaseGroupForm, _Component);

  var _super = _createSuper(BaseGroupForm);

  function BaseGroupForm(props) {
    var _this;

    _classCallCheck(this, BaseGroupForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.baseGroup != null && nextProps.baseGroup != _this.props.baseGroup) {
        _this.setState({
          units: nextProps.baseGroup.units,
          title: nextProps.baseGroup.title
        });
      }

      if (nextProps.baseGroup == null && nextProps.baseGroup != _this.props.baseGroup) {
        _this.setState({
          units: [],
          title: ''
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.state.units.length > 0) {
        // Trigger onUpdate event when this form mounts and the value isnt empty
        _this.onUpdate();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getUnassignedStudents", function () {
      var students = [];

      _this.props.section.students.forEach(function (student) {
        var isSelected = _this.state.units.find(function (unit) {
          return unit.memberships.find(function (member) {
            return student.userId == member.userId;
          });
        });

        if (isSelected != null) {
          return false;
        }

        students.push(student);
      });

      return students;
    });

    _defineProperty(_assertThisInitialized(_this), "setTitle", function (event) {
      return _this.setState({
        title: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdate", function () {
      if (_this.props.onUpdate != null) {
        _this.props.onUpdate(_this.state.units);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "randomUnitsSubmit", function (units) {
      _this.setState({
        units: units
      }, function () {
        _this.onUpdate();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentActiveToggle", function (student) {
      var activeStudents = _this.state.activeStudents;

      var studentIndex = _this.state.activeStudents.findIndex(function (activeStudent) {
        return activeStudent.userId == student.userId;
      });

      if (studentIndex > -1) {
        activeStudents.splice(studentIndex, 1);
      } else {
        activeStudents.push(student);
      }

      _this.setState({
        activeStudents: activeStudents
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentSelect", function (student, unitTitle) {
      var units = _this.state.units;
      var unit = units.find(function (unit) {
        return unit.title == unitTitle;
      });

      if (unit == null) {
        unit = _this.addUnit();
      }

      var isSelected = _this.state.units.find(function (unit) {
        return unit.memberships.find(function (member) {
          return student.userId == member.userId;
        });
      });

      if (isSelected != null) {
        var inMemberships = isSelected.memberships.findIndex(function (member) {
          return student.userId == member.userId;
        });

        if (inMemberships > -1) {
          isSelected.memberships.splice(inMemberships, 1);
        }

        if (unit != null && unit.title != isSelected.title) {
          unit.memberships.push({
            userId: student.userId,
            user: student
          });
        }
      } else {
        unit.memberships.push({
          userId: student.userId,
          user: student
        });
      }

      _this.setState({
        units: units
      }, function () {
        _this.onUpdate();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "assignStudentToNewGroup", function (student) {
      var unit = _this.addUnit();

      _this.onStudentSelect(student, unit.title);
    });

    _defineProperty(_assertThisInitialized(_this), "setGroupOnActiveStudents", function (unitTitle) {
      _this.state.activeStudents.forEach(function (student) {
        _this.onStudentSelect(student, unitTitle);
      });

      _this.setState({
        activeStudents: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createGroupWithActiveStudents", function () {
      var unit = _this.addUnit();

      _this.setGroupOnActiveStudents(unit.title);
    });

    _defineProperty(_assertThisInitialized(_this), "addUnit", function (e) {
      if (e != null) {
        e.preventDefault();
      }

      var units = _this.state.units;
      var unit = {
        title: _this.props.translate('group') + ' ' + (_this.state.units.length + 1),
        memberships: []
      };
      units.push(unit);

      _this.setState({
        units: units
      }, function () {
        _this.onUpdate();
      });

      return unit;
    });

    _defineProperty(_assertThisInitialized(_this), "removeUnit", function (unitTitle) {
      var units = _this.state.units;
      var unitIndex = units.findIndex(function (unit) {
        return unit.title == unitTitle;
      });

      if (unitIndex > -1) {
        units.splice(unitIndex, 1);
        units.forEach(function (unit, index) {
          unit.title = _this.props.translate('group') + ' ' + (index + 1);
          return unit;
        });

        _this.setState({
          units: units
        }, function () {
          _this.onUpdate();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "editUnitTitle", function (unit) {
      var translate = _this.props.translate;
      var units = _this.state.units;
      swal.fire({
        title: translate('edit-name'),
        text: translate('name'),
        input: 'text',
        inputValue: unit.title,
        showCancelButton: true,
        cancelButtonText: translate('Cancel'),
        confirmButtonText: translate('save'),
        preConfirm: function preConfirm(value) {
          if (value.length > 50) {
            return swal.showValidationMessage(translate('Group name can not be longer than 50 characters'));
          }

          return undefined;
        }
      }).then(function (response) {
        if (response.value != null) {
          unit.title = response.value;

          _this.setState({
            units: units
          }, function () {
            _this.onUpdate();
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (e) {
      if (e != null) {
        e.preventDefault();
      }

      if (_this.props.onSubmit != null) {
        if (_this.props.baseGroup != null) {
          var values = _objectSpread({}, _this.props.baseGroup);

          values.title = _this.state.title;
          values.units = _this.state.units;

          _this.setState({
            submitting: true
          });

          _this.props.onSubmit(values).then(function () {
            _this.setState({
              submitting: false
            });
          });
        } else {
          var _values = {
            title: _this.state.title,
            sectionId: _this.props.section.id,
            units: _this.state.units
          };

          _this.setState({
            submitting: true
          });

          _this.props.onSubmit(_values).then(function () {
            _this.setState({
              submitting: false
            });
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudent", function (student, index) {
      var options = [];

      var isActive = _this.state.activeStudents.find(function (activeStudent) {
        return activeStudent.userId == student.userId;
      });

      var unit = _this.state.units.find(function (unit) {
        return unit.memberships.find(function (member) {
          return member.userId == student.userId;
        });
      });

      _this.state.units.forEach(function (unit) {
        options.push({
          value: unit.title,
          label: unit.title
        });
      });

      options.push({
        value: 'new',
        label: _this.props.translate('new-group')
      });
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.35rem'
        },
        key: student.userId
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: isActive != null,
        label: student.firstName + ' ' + student.lastName,
        onChange: function onChange() {
          return _this.onStudentActiveToggle(student);
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "float--right"
      }, /*#__PURE__*/React.createElement(Select, {
        onChange: function onChange(value) {
          return _this.onStudentSelect(student, value);
        },
        options: options
      }, unit != null ? unit.title : _this.props.translate('select-group'))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    });

    var _units = [];
    var title = '';

    if (props.baseGroup != null) {
      _units = props.baseGroup.units;
      title = props.baseGroup.title;
    }

    _this.state = {
      title: title,
      units: _units,
      activeStudents: [],
      submitting: false
    };
    return _this;
  }

  _createClass(BaseGroupForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var section = this.props.section;
      var _this$state = this.state,
          units = _this$state.units,
          title = _this$state.title;
      var unassignedStudents = this.getUnassignedStudents();
      return /*#__PURE__*/React.createElement("div", {
        className: "basegroups create"
      }, this.state.submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, !this.props.hideTitle ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem'
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'block',
          marginBottom: 'var(--size-10)'
        }
      }, this.props.translate('title')), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: 0
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        value: this.state.title,
        onChange: this.setTitle
      }))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem'
        }
      }), this.props.baseGroup == null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'block',
          marginBottom: 'var(--size-10)'
        }
      }, this.props.translate('automatically-divide')), /*#__PURE__*/React.createElement(GenerateBaseGroupsRandomly, {
        onSubmit: this.randomUnitsSubmit,
        students: this.props.section.students
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.85rem'
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400
        }
      }, this.props.translate('Groups')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.addUnit
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate('add-group'))), this.state.units.map(function (unit, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "unit",
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "title"
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            flex: 1
          }
        }, unit.title), /*#__PURE__*/React.createElement(TooltipMenu, {
          id: 'unit-menu-' + index,
          trigger: /*#__PURE__*/React.createElement(Icon, {
            name: "Bullets"
          })
        }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.editUnitTitle(unit);
          }
        }, _this2.props.translate('edit-name')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.removeUnit(unit.title);
          }
        }, _this2.props.translate('Remove')))), unit.memberships.map(function (membership, index) {
          return _this2.renderStudent(membership.user, index);
        }));
      }), unassignedStudents.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "unit"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('unassigned-students')), unassignedStudents.map(function (student, index) {
        return _this2.renderStudent(student, index);
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem'
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "action-buttons"
      }, /*#__PURE__*/React.createElement("div", {
        className: "larger"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          disabled: this.state.activeStudents.length == 0
        }, this.props.translate('select-group-for-selected-students'), " ", /*#__PURE__*/React.createElement(Icon, {
          name: "Chevron"
        })),
        id: "createBaseGroupSelectedStudentsTooltip"
      }, this.state.units.map(function (unit) {
        return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          key: unit.title,
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.setGroupOnActiveStudents(unit.title);
          }
        }, unit.title);
      }), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.createGroupWithActiveStudents();
        }
      }, this.props.translate('new-group'))))), this.props.actions != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 0
        }
      }, this.props.actions.map(function (action, index) {
        return /*#__PURE__*/React.createElement(Button, {
          key: index,
          onClick: action.onClick,
          type: action.type
        }, action.value);
      })) : null), this.props.onSubmit != null ? /*#__PURE__*/React.createElement("div", {
        className: "button-row"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: units.length == 0 || title.length == 0,
        onClick: this.onSubmit
      }, this.props.translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })) : null);
    }
  }]);

  return BaseGroupForm;
}(Component);

_defineProperty(BaseGroupForm, "defaultProps", {
  hideTitle: false
});

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(BaseGroupForm);